export const T = {
  en_GB: {
    droppedFundsWarning: "will be removed at the bank — no matching product:",
    noGoal: "No goal",
    agreement: "Agreement",
    account: "Account",
    carriesMandate: (name: string) => `Carries mandate ${name}`,
    position: "position",
    positions: "positions",
  },
  nb_NO: {
    droppedFundsWarning: "fjernes hos banken — mangler produkt:",
    noGoal: "Uten mål",
    agreement: "Avtale",
    account: "Konto",
    carriesMandate: (name: string) => `Bærer mandat ${name}`,
    position: "posisjon",
    positions: "posisjoner",
  },
} as const;
